import { apiInterfaceForJson } from "../common/apiManager";

// --- Agent (own) ---
export const clockIn = () => {
    return apiInterfaceForJson("/work-session/v1/clock-in", "POST");
};

export const clockOut = () => {
    return apiInterfaceForJson("/work-session/v1/clock-out", "POST");
};

export const getMyStatus = () => {
    return apiInterfaceForJson("/work-session/v1/me/status", "GET");
};

export const getMyMonthly = (month) => {
    const q = month ? `?month=${encodeURIComponent(month)}` : "";
    return apiInterfaceForJson(`/work-session/v1/me/monthly${q}`, "GET");
};

// --- Admin ---
export const getAdminOverview = (month) => {
    const q = month ? `?month=${encodeURIComponent(month)}` : "";
    return apiInterfaceForJson(`/work-session/v1/admin/overview${q}`, "GET");
};

export const getAdminAgentMonthly = (agentId, month) => {
    const q = month ? `?month=${encodeURIComponent(month)}` : "";
    return apiInterfaceForJson(`/work-session/v1/admin/agent/${agentId}/monthly${q}`, "GET");
};

export const upsertWorkSession = (payload) => {
    return apiInterfaceForJson("/work-session/v1/admin/session", "POST", payload);
};

export const deleteWorkSession = (sessionId) => {
    return apiInterfaceForJson(`/work-session/v1/admin/session/${sessionId}`, "DELETE");
};

// --- Day-offs (admin) ---
export const getAgentDayOffs = (agentId, month) => {
    const q = month ? `?month=${encodeURIComponent(month)}` : "";
    return apiInterfaceForJson(`/work-session/v1/admin/agent/${agentId}/day-offs${q}`, "GET");
};

export const addDayOff = (payload) => {
    return apiInterfaceForJson("/work-session/v1/admin/day-off", "POST", payload);
};

export const deleteDayOff = (id) => {
    return apiInterfaceForJson(`/work-session/v1/admin/day-off/${id}`, "DELETE");
};

export const setAgentAllowance = (agentId, allowance) => {
    return apiInterfaceForJson(`/work-session/v1/admin/agent/${agentId}/allowance`, "PATCH", { allowance });
};

export const setDefaultAllowance = (allowance) => {
    return apiInterfaceForJson("/work-session/v1/admin/day-off-default", "PATCH", { allowance });
};

export const setWorkSchedule = (schedule) => {
    return apiInterfaceForJson("/work-session/v1/admin/schedule", "PATCH", schedule);
};
